import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { TrendingUp, Shield, Users, Zap } from "lucide-react"

const features = [
  {
    icon: TrendingUp,
    title: "Ein System, das Vermieter stärkt",
    description: "Überschuss-Rückvergütung und Lösungen, die entlasten.",
    highlight: true
  },
  {
    icon: Shield,
    title: "Sicher & Transparent",
    description: "Vermieten ohne Frust - klar und auf Augenhöhe mit allen Beteiligten."
  },
  {
    icon: Users,
    title: "Von Vermietern für Vermieter",
    description: "Echtes Praxiswissen statt Theorie - wir verstehen Ihre Bedürfnisse."
  },
  {
    icon: Zap,
    title: "Genossenschaftlich organisiert",
    description: "Die gemeinschaftliche Lösung für kurzfristige Vermietungen."
  }
]

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Warum Fair-Stays?
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Die genossenschaftliche Plattform für Vermieter und Gäste
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className={`relative transition-all duration-300 hover:shadow-lg hover:-translate-y-1 border-0 ${
                feature.highlight 
                  ? 'bg-primary text-primary-foreground shadow-lg' 
                  : 'bg-card shadow-sm'
              }`}
            >
              <CardHeader className="pb-2">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-3 ${
                  feature.highlight 
                    ? 'bg-primary-foreground/20' 
                    : 'bg-primary/10'
                }`}>
                  <feature.icon className={`h-6 w-6 ${
                    feature.highlight 
                      ? 'text-primary-foreground' 
                      : 'text-primary'
                  }`} />
                </div>
                <CardTitle className={`text-lg ${
                  feature.highlight 
                    ? 'text-primary-foreground' 
                    : 'text-foreground'
                }`}>
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className={`text-sm ${
                  feature.highlight 
                    ? 'text-primary-foreground/80' 
                    : 'text-muted-foreground'
                }`}>
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection